import React, { useState } from "react";
import "./login.css";
import { Form, Input, Button, Checkbox } from "antd";
import { DeviceUUID } from "device-uuid";
import { callApi } from "../../../api/apiCaller";
import { useDispatch } from "react-redux";
import {
  accessToken,
  refreshToken,
  userData,
} from "../../../redux/userDataSlice";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../api/routes";
import Loader from "../../../components/loader/loader";
import { GreenNotify, RedNotify } from "../../../helper/helper";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isloading, setIsLoading] = useState(false);

  const onFinish = (values) => {
    let deviceId = localStorage.getItem("deviceId");
    if (!deviceId) {
      let id = new DeviceUUID().get();
      localStorage.setItem("deviceId", id);
      deviceId = id;
    }

    let getRes = (res) => {
      if (res.status === 200) {
        console.log("res of login", res);
        dispatch(userData(res?.data?.user));
        dispatch(accessToken(res?.data?.token));
        dispatch(refreshToken(res?.data?.refreshToken));
        GreenNotify("Login Successfully");
        navigate("/", { replace: true });
      } else {
        RedNotify(res.message);
      }
    };
    let body = {
      email: values.email,
      password: values.password,
      device: { id: deviceId, deviceToken: "angg" },
    };
    callApi("POST", routes.signIn, body, setIsLoading, getRes, (error) => {});
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="admin-panel-login">
      <Loader loading={isloading} />
      
      {/* Background decorative elements */}
      <div className="login-bg-decoration">
        <div className="circle circle-1"></div>
        <div className="circle circle-2"></div>
        <div className="circle circle-3"></div>
      </div>

      <div className="login-main-container">
        <div className="login-card">
          {/* Logo Section */}
          <div className="login-logo-section">
            <img 
              src="/jak.png" 
              alt="JAK Logo" 
              className="login-logo"
            />
            <h1 className="login-title">Admin Panel</h1>
            <p className="login-subtitle">Welcome back! Please login to continue</p>
          </div>

          {/* Form Section */}
          <div className="login-form-section">
            <Form
              name="basic"
              layout="vertical"
              initialValues={{
                remember: true,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              className="login-form"
            >
              <Form.Item
                label={<span className="form-label">Email Address</span>}
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please input your Email!",
                  },
                  {
                    type: "email",
                    message: "Please enter a valid email!",
                  },
                ]}
              >
                <Input 
                  placeholder="Enter your email"
                  className="login-input"
                  size="large"
                />
              </Form.Item>

              <Form.Item
                label={<span className="form-label">Password</span>}
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please input your password!",
                  },
                ]}
              >
                <Input.Password 
                  placeholder="Enter your password"
                  className="login-input"
                  size="large"
                />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-submit-btn"
                  size="large"
                  block
                >
                  Login to Dashboard
                </Button>
              </Form.Item>
            </Form>
          </div>

          {/* Footer */}
          <div className="login-footer">
            <p>© 2025 JAK. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
